// extracted by mini-css-extract-plugin
export default {"resetButton":"VsQiy04","root":"FJmQm1y","appName":"DTsvGAv","appVersion":"WpGoy0_"};